export type PriceType = 'default' | 'custom-lower' | 'custom-higher' | 'custom-same'

/**
 * Helper to get CSS color class for price type
 */
export function getPriceColorClass(priceType: PriceType): string {
  switch (priceType) {
    case 'custom-lower':
      return 'text-green-600' // Green for lower price
    case 'custom-higher':
      return 'text-red-600' // Red for higher price
    case 'custom-same':
      return 'text-orange-600' // Orange for same price (edge case)
    case 'default':
    default:
      return 'text-gray-900' // Default color
  }
}

/**
 * Helper to format price difference for tooltip
 */
export function formatPriceDifference(percentageDiff: number | null): string | null {
  if (percentageDiff == null) return null

  const sign = percentageDiff > 0 ? '+' : ''
  return `${sign}${percentageDiff.toFixed(1)}%`
}
